/**
 * Sanitize a return-to URL to prevent open redirect attacks.
 * Only allows relative paths (starting with /) and rejects protocol-relative URLs (//).
 */
export function sanitizeReturnTo(url: string): string {
  return url.startsWith('/') && !url.startsWith('//') ? url : '/v2/dashboard';
}
